module.exports = __webpack_public_path__ + "media/country_flags/ms-bbef5207.png";